export const filterData = <T extends Record<string, unknown>>(
  data: T[],
  searchString?: string,
  searchKeys?: string[]
): T[] => {
  if (!searchString || !searchKeys) return data;

  const regex = new RegExp(
    searchString.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'),
    'i'
  );
  return data.filter((value) =>
    searchKeys.some((key) => value[key] && regex.test(String(value[key])))
  );
};
